import {Component, computed, Input, ViewChild, ViewEncapsulation} from '@angular/core';
import {DxReportDesignerModule, DxReportDesignerComponent, DxReportViewerRemoteSettingsComponent} from 'devexpress-reporting-angular';
import 'devexpress-reporting/dx-richedit';
import { User } from '../../../Api/DcoApi/Client/RestClient'
import {Report} from '../../../Api/DcoApi/Reporting/Report';
import { fetchSetup } from '@devexpress/analytics-core/analytics-utils';
import {DataGridView} from '../../../Componente/DataGridView';
import {GeraeteModell} from '../../../Api/DcoApi/Admin/AdminClasses2';

@Component({
  selector: 'report-designer',
  imports: [DxReportDesignerModule, DxReportViewerRemoteSettingsComponent],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './report-designer.html',
  styleUrls: [
    './report-designer.css',
    "../../../../../node_modules/ace-builds/css/ace.css",
    "../../../../../node_modules/ace-builds/css/theme/dreamweaver.css",
    "../../../../../node_modules/ace-builds/css/theme/ambiance.css",
    "../../../../../node_modules/devextreme/dist/css/dx.light.css",
    "../../../../../node_modules/devexpress-richedit/dist/dx.richedit.css",
    "../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css",
    "../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css",
    "../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-querybuilder.css",
    "../../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css",
    "../../../../../node_modules/devexpress-reporting/dist/css/dx-reportdesigner.css"
  ],
})
export class ReportDesigner {
  @Input() Report:Report = { key: 0, createdAt: new Date(), updatedAt: new Date(), bezeichnung: '' } as Report;
  Host = () => { return `/Backend/Api/V2/ReportAdmin/Reports/` };
  ReportName = () => { return `${this.Report?.bezeichnung}` };
  getDesignerModelAction = () => { return `${this.Report?.key}` };
  @ViewChild('Editor') childComponent!: DxReportDesignerComponent;

  constructor() {
    fetchSetup.fetchSettings = {
      headers: {  'Authorization': "Bearer " + User.Token },
      //the void return type was extended with Promise starting v24.1.4+
      beforeSend: (requestParameters) => {
        requestParameters.credentials = 'include';
      }
    };

  }

  CustomizeElements(ev:any)
  {
    console.log(ev);
  }
  CustomizeMenuActions(ev: any)
  {
    var items = ev.args.Actions.filter((o :any) => o.container == 'menu');
    items.forEach((o :any) => {

      o.visible = false
      try {
        o.disabled(true)
      }
      catch {

      }

    });
    ev.args.Actions =ev.args.Actions.filter((o :any) => o.container !== 'menu');
    console.log(ev);
  }

  public Save()
  {
    const designerModel = this.childComponent.bindingSender;
    designerModel.SaveNewReport(this.Report.key.toString());
  }

  protected readonly User = User;
}
